import React, { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { Menu, X, User } from "lucide-react";
import { Wordmark } from "@/components/Emblem";
import { GoldButton } from "@/components/shared";
import { useAuth } from "@/context/AuthContext";

const NAV = [
  { label: "Two Bostons", to: "/lincolnshire" },
  { label: "Made", to: "/made" },
  { label: "Trade", to: "/trade" },
  { label: "Tourism", to: "/tourism" },
  { label: "Forum", to: "/forum" },
  { label: "2030", to: "/2030" },
  { label: "Journal", to: "/journal" },
];

export default function Header() {
  const [open, setOpen] = useState(false);
  const { user } = useAuth();
  const loc = useLocation();

  return (
    <header className="sticky top-0 z-50 bg-[#F8F1E7]/95 backdrop-blur-md border-b border-[#D6D3CB] shadow-sm">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-[68px]">
          <Wordmark />

          <nav className="hidden lg:flex items-center gap-1">
            {NAV.map((n) => {
              const active = loc.pathname === n.to;
              return (
                <Link
                  key={n.to}
                  to={n.to}
                  data-testid={`nav-${n.label.toLowerCase().replace(/\s+/g, "-")}`}
                  className={`font-sans text-sm font-medium px-3 py-2 transition-colors ${
                    active ? "text-[#003366]" : "text-[#1B2430] hover:text-[#003366]"
                  } hover:bg-[#003366]/5`}
                >
                  {n.label}
                </Link>
              );
            })}
          </nav>

          <div className="hidden lg:flex items-center gap-3">
            <GoldButton as="link" to="/join" data-testid="header-list-business" className="px-4 py-2">
              List a business
            </GoldButton>
            {user ? (
              <Link
                to="/account"
                data-testid="header-account"
                className="flex items-center gap-2 font-sans text-sm font-medium text-[#1B2430] hover:text-[#003366] px-3 py-2"
              >
                <User size={16} /> Account
              </Link>
            ) : (
              <Link
                to="/signin"
                data-testid="header-signin"
                className="font-sans text-sm font-medium text-[#1B2430] hover:text-[#003366] px-3 py-2"
              >
                Sign in
              </Link>
            )}
          </div>

          <button
            className="lg:hidden p-2 text-[#1E1E2F]"
            onClick={() => setOpen((o) => !o)}
            data-testid="mobile-menu-toggle"
            aria-label="Menu"
          >
            {open ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>
      </div>

      {open && (
        <div className="lg:hidden bg-[#F8F1E7] border-t border-[#D6D3CB]">
          <div className="px-4 py-4 space-y-1">
            {NAV.map((n) => (
              <Link
                key={n.to}
                to={n.to}
                onClick={() => setOpen(false)}
                data-testid={`mobile-nav-${n.label.toLowerCase().replace(/\s+/g, "-")}`}
                className="block font-sans text-sm font-medium text-[#1B2430] hover:text-[#003366] py-2.5 border-b border-[#D6D3CB]/60"
              >
                {n.label}
              </Link>
            ))}
            <div className="flex items-center gap-3 pt-4">
              <GoldButton as="link" to="/join" onClick={() => setOpen(false)} className="flex-1">
                List a business
              </GoldButton>
              <Link
                to={user ? "/account" : "/signin"}
                onClick={() => setOpen(false)}
                className="font-sans text-sm font-medium text-[#003366] px-3 py-2"
              >
                {user ? "Account" : "Sign in"}
              </Link>
            </div>
          </div>
        </div>
      )}
    </header>
  );
}
